import { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { api, extractErrorMessage } from "../../../../util/api";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { AvailityErrorRuleForm } from "./AvailityErrorRuleForm";

export const AvailityErrorRuleModal = ({ rule, onSaved, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const isEdit = Boolean(rule);
  const toggle = () => setOpen((value) => !value);

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const payload = snakifyKeys({ availityErrorRule: values });
      const response = isEdit
        ? await api.put(`/admin/availity_error_rules/${rule.id}`, payload)
        : await api.post("/admin/availity_error_rules", payload);

      onSaved(response.data.resource);
      setOpen(false);
    } catch (requestError) {
      setError(extractErrorMessage(requestError));
    }
  };

  return (
    <>
      <Button onClick={toggle} {...rest}>
        {isEdit ? "Edit" : "Add Rule"}
      </Button>
      <Modal isOpen={open} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{isEdit ? "Edit Availity Error Rule" : "Add Availity Error Rule"}</ModalHeader>
        <ModalBody>
          <DetailedErrorAlert error={error} />
          <Form destroyOnUnregister onSubmit={handleSubmit} initialValues={camelizeKeys(rule || {})}>
            {(props) => <AvailityErrorRuleForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
